.Editor > div {
  outline: none;
}
